<template>
    <div v-if="value">
        <van-popup v-model="show" class="comPopup_container" position="bottom" :closeable="true" :style="{ 'min-height': '50%' }" @close="$emit('closePopup')">
            <!-- 底部弹出层 -->
            <div class="comPopup_title popupfont">
                {{ title }}
            </div>
            <div class="comPopup_content pr-1 pl-1">
                <slot>
                    <div v-if="hasDefaultContent" class="default-content">
                        <div :class="['default-content-items' , index == content.length - 1 || !content[index + 1].title ||  !item.title ? '' : 'mb-1']" v-for="(item , index) in content" :key="index">
                            <div class="default-content-item" v-if="item.title">
                                <div class="default-content-title mb-1">
                                    <span>{{item.title}}</span>
                                    <span>{{item.currency}}</span>
                                </div>
                                <div class="default-content-content">
                                    <img :src="item.icon" alt="">
                                    <span>{{item.amount}}</span>
                                    <span>{{item.currency}}</span>
                                </div>
                            </div>
                            <div class="default-content-clear" v-else>
                                <img :src="item.icon" alt="">
                            </div>
                        </div>
                    </div>
                </slot>
                <div class="clear_box"></div>
                <ComButton class="popupBtn" @click="clickPopup">{{btnLabel}}</ComButton>
            </div>
        </van-popup>
    </div>
</template >

<script>
export default {
    name: 'ComPopup',
    props: {
        value:{
            type: Boolean,
            default: false
        },
        title:{
            type: String,
            default: ''
        },
        content:{
            type: Array,
            default: []
        },
        btnLabel:{
            type: String,
            default: '确认'
        }
    },
    data(){
        return {
            hasDefaultContent: true,
            show: false
        }
    },
    mounted(){
        this.hasDefaultContent = !this.$slots.default;
    },
    methods:{
        clickPopup(){
            
            this.$emit('clickPopup')
        }
    },
    watch:{
        value: {
            immediate: true, 
            handler(val) {
                this.show = val
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>